import enUSPicker from 'antd/lib/date-picker/locale/en_US';
import ruPicker from 'antd/lib/date-picker/locale/ru_RU';
import { useTranslation } from 'react-i18next';

/**
 * The date pickers' own copy (placeholders, month names, "Now", "OK") in the portal's language — the
 * pickers are generated from date-fns, so they do not pick antd's ConfigProvider locale up by
 * themselves (the session form passes it the same way).
 */
export const usePickerLocale = () => {
  const { i18n } = useTranslation();
  return i18n.languages[0]?.startsWith('ru') ? ruPicker : enUSPicker;
};
